// Renders estimated or live focus duration for a task row or detail surface.
import { useT } from '@/i18n/useT';
import { FocusedDurationBadge } from './FocusedDurationBadge';
import { StaticDurationBadge } from './StaticDurationBadge';

const TaskDurationBadge = ({
  isFocused,
  focusStartTime,
  displayDuration,
  estimatedDuration = null,
  isRollup,
  className = 'task-duration',
  showIcon = true,
  showPrefix = true,
}) => {
  const t = useT();

  if (isFocused && focusStartTime) {
    return (
      <FocusedDurationBadge
        focusStartTime={focusStartTime}
        estimatedDuration={estimatedDuration}
        displayDuration={displayDuration}
        className={className}
      />
    );
  }

  if (displayDuration > 0) {
    const title = isRollup
      ? t(
          'taskdetailmetadata.rollupDuration',
          'Calculated duration (sum of subtasks)',
        )
      : t('taskdetailmetadata.estimatedDuration', 'Estimated duration');
    return (
      <StaticDurationBadge
        displayDuration={displayDuration}
        isRollup={isRollup}
        className={className}
        showIcon={showIcon}
        showPrefix={showPrefix}
        title={title}
      />
    );
  }

  return null;
};

export default TaskDurationBadge;
